<template>
  <v-layout class="rating-configurator" wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex mt-3 xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('driverRating.configurtor') }}</h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-tabs class="rating-configurator__tabs" color="warning" vertical>
      <v-tab v-for="(tab, key) in tabs" :key="key">
        {{ tab.title }}
      </v-tab>

      <v-tab-item v-for="(tab, key) in tabs" :key="key">
        <rating-configurator-table
          v-bind="tab"
          :loading="loading"
          @updated="proccessResult"
        />
      </v-tab-item>
    </v-tabs>

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import RatingConfiguratorTable from '@/components/driver/RatingConfiguratorTable.vue';
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  components: { RatingConfiguratorTable },
  data: () => ({
    loading: false,
    tab: 0,
    snack: {
      opened: false,
      message: '',
      color: '',
    },
  }),
  computed: {
    configuratorList() {
      return this.$store.state.driver.configuratorList;
    },
    tabs() {
      return [
        { title: this.$t('driverRating.configurtor.insurance'), type: 1 },
        {
          title: this.$t('driverRating.configurtor.age'),
          onlyNumbersName: true,
          type: 2,
        },
        {
          title: this.$t('driverRating.configurtor.experience'),
          onlyNumbersName: true,
          type: 3,
        },
        {
          title: this.$t('driverRating.configurtor.stability'),
          onlyNumbersName: true,
          type: 4,
        },
      ];
    },
  },
  methods: {
    proccessResult({ success }) {
      const snack = {
        opened: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (success) {
        this.fetchList();
      } else {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      this.snack = snack;
    },
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('driver/fetchRatingConfigurator');
      this.loading = false;
    },
  },
  async created() {
    this.fetchList();
  },
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('finance_rating_config', next);
  },
};
</script>

<style lang="scss">
.rating-configurator {
  &__tabs {
    margin-top: 30px;
    border-radius: 5px;
    border: 2px solid #eee !important;
    overflow: hidden;
  }

  .v-tab {
    min-width: 300px;
  }

  .v-slide-group__wrapper {
    border-right: 1px solid #eee !important;
  }
}
</style>
